export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2025 (CLASS - 9).09c186a4.pdf";